import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';

/**
 * Generated class for the UrunAktarModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-urun-aktar-modal',
  templateUrl: 'urun-aktar-modal.html',
})
export class UrunAktarModalPage {
  Hareket: any = { ID: -1, StokHareketID: "", Miktar: "", StokID: "", DepoID: "", IslemiYapanKullaniciID: "", IslemTuru: "" };
  vwKayit: any = {};
  vwHareket: any = {};
  islemyapan = this.ortak.storagePersonelGetir.Name;
  constructor(public navCtrl: NavController,
    public ortak: Ortak,
    public viewCtrl: ViewController,
    public bllOrtak: BllOrtak,
    public navParams: NavParams) {
    if (navParams.get("vwKayit") != null) {
      this.vwKayit = navParams.get("vwKayit");
      this.vwHareket = navParams.get("vwHareket");
      console.log("VD", this.vwHareket)
      this.Hareket.DepoAdi=this.vwKayit.DepoAdi;
      console.log("aa", this.Hareket)
      var data = new FormData();
      data.append("Hareket_id", this.vwKayit.ID);
      this.bllOrtak.islem(data, "StokHareketGetirByID", "", false).then(a => {
        var Sonuc = <any>a;



      }
      )

    }

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad UrunAktarModalPage');
  }
  kapat() {
    this.viewCtrl.dismiss();
  }
  Kaydet() {
    this.Hareket.StokHareketID=this.vwHareket.ID;
    this.Hareket.StokID=this.vwHareket.StokKartID;
    this.Hareket.IslemiYapanKullaniciID=1;
    this.Hareket.DepoID=this.vwKayit.ID;

    console.log("gidenhareket",this.Hareket)
    var formData = new FormData();
    formData.append("Aktarilan_json",JSON.stringify(this.Hareket));
    this.bllOrtak.islem(formData, "DepoyaAktar", "", true).then(a => {
      var sonuc = <any>a;
      if (sonuc.Sonuc == 1) this.ortak.showBasicAlert("Başarılı", "İşlem Başarılı");
      
      this.kapat();

    })
  }
}




// WEBPACK FOOTER //
// ./src/pages/MalKayit/urun-aktar-modal/urun-aktar-modal.ts